import { render, staticRenderFns } from "./DateTimeDisplay.vue?vue&type=template&id=56f729b2&"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f729b2')) {
      api.createRecord('56f729b2', component.options)
    } else {
      api.reload('56f729b2', component.options)
    }
    module.hot.accept("./DateTimeDisplay.vue?vue&type=template&id=56f729b2&", function () {
      api.rerender('56f729b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DateTimeDisplay.vue"
export default component.exports